import { connect } from "react-redux";
// API
import api from "api";
// Action
import { openErrorDialog } from "redux/modules/errorDialog";
import {
  initReport,
  setReport,
  setLocale,
  setReportStatus,
  setReportByAttrStatus,
  setEditStatus,
  openIndustryModal,
  openIndustryByAttrModal,
  closeIndustryModal,
  closeIndustryByAttrModal,
  changeIndustryModal,
  decideIndustry,
  decideIndustryByAttr,
  setErrors,
  setLoading,
  setSurveyAttrShowStatus
} from "redux/modules/report";
import { isPlatform } from "utils/formatter";

// Component
import Report from "components/Report";
// Utils
import history from "utils/history";
import { showSnackbar } from "redux/modules/snackbar";
import moment from "moment";

// 日付形式の定数（保存値のセット、または変更時の値のセットのフォーマット）
const DATE_FORMAT = "YYYY-MM-DD";

const mapStateToProps = state => {
  return { ...state };
};

const createCSVContent = (data, fileName) => {
  // BOM の用意(文字化け対策)
  const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
  // BOM 付き CSV ファイルの元となる Blob を作成
  const blob = new Blob([bom, data], { type: "text/csv" });

  if (isPlatform("IE")) {
    // IE
    window.navigator.msSaveBlob(blob, fileName);
  } else {
    // createObjectURL を使って Blob URL を構築
    const link = document.createElement("a");
    link.style = "visibility:hidden";
    link.href = (window.URL || window.webkitURL).createObjectURL(blob);
    // ファイル名はサーバから取得
    link.download = fileName;
    // ダウンロード後、リンクは削除
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
const mapDispatchToProps = (dispatch, ownProps) => ({
  historyPush: path => history.push(path, ownProps),
  initReport: () => {
    dispatch(initReport());
  },
  fetchReport: () => {
    const { id } = ownProps.match.params;
    api
      .get(`survey_progress/${id}`)
      .then(res => dispatch(setReport(res)))
      .catch(error => dispatch(openErrorDialog(error)));
  },
  updateReportStatus: (params, surveyAttrs, isChecked, termFrom) => {
    const errors = [];
    const { id } = ownProps.match.params;
    const paramData = params.toJS();
    const checkboxKeys = [
      "diffAll",
      "diffTime1",
      "diffTime2",
      "diffTime3",
      "diffManufacture",
      "diffNonManufacture",
      "diffBigCorp",
      "diffSmallCorp",
      "diffIndustry1",
      "diffIndustry2",
      "diffIndustry3"
    ];
    const checkedCount = checkboxKeys.filter(key => paramData[key] === true || paramData[key] === 1).length;

    const invalidSelections = [];

    surveyAttrs.forEach((attr) => {
      if (!Array.isArray(attr.items)) return;

      attr.items.forEach((item) => {
        if (!Array.isArray(item) || item.length < 21) return;

        const majorChecks = [
          { checkIdx: 18, majorIdx: 18 },
          { checkIdx: 19, majorIdx: 19 },
          { checkIdx: 20, majorIdx: 20 },
        ];

        majorChecks.forEach(({ checkIdx, majorIdx }) => {
          const isAttrChecked = item[checkIdx];
          const majorSelected = item[majorIdx];

          if (isAttrChecked && typeof majorSelected !== 'number') {
            invalidSelections.push(true);
          }
        });
      });
    });

    if (invalidSelections.length > 0) {
      errors.push("産業分類を選択してください。");
    }

    const MONITORED_INDEXES = [5, 6, 7, 8, 9, 10, 14, 15, 18, 19, 20];

    if (Array.isArray(surveyAttrs)) {
      surveyAttrs.forEach((attr) => {
        if (!Array.isArray(attr.items)) return;

        attr.items.forEach((item) => {
          if (!Array.isArray(item) || item.length < 21) return;

          const checkedAttrCount = MONITORED_INDEXES.reduce((count, idx) => {
            return count + (item[idx] ? 1 : 0);
          }, 0);

          if (checkedAttrCount > 4) {
            errors.push("質問別結果指数一覧は5つ以上選択できません");
          }
        });
      });
    }
    // 産業分類のエラーチェック
    if ((params.diffIndustry1 && !params.industryParentId1)
      || (params.diffIndustry2 && !params.industryParentId2)
      || (params.diffIndustry3 && !params.industryParentId3)) {
      errors.push('産業分類を選択してください。');
    }

    if (isChecked && !termFrom) {
      errors.push('レポート日付を設定してください。');
    }

    if (checkedCount > 4) {
      errors.push('質問別結果指数一覧は5つ以上選択できません。');
    }

    dispatch(setErrors(errors));
    if (errors.length > 0) {
      window.scroll(0, 0);
      return;
    }

    const formattedDate = moment(termFrom, "YYYYMMDDHHmm").format(DATE_FORMAT);

    const reportStatus = {
      reportStatus: {
        ...params.toJS(),
        reportDate: formattedDate || null,
      },
    };
    api
      .post(`survey_progress/update/${id}`, reportStatus)
      .then(res => {
        dispatch(setReportStatus(res, 'update'));
        dispatch(showSnackbar("出力設定を変更しました。"));
      })
      .catch(error => dispatch(openErrorDialog(error)));

    api
      .post(`survey_progress/update_attr_report/${id}`, { surveyAttrs })
      .then(() => {
        dispatch(showSnackbar("出力設定を変更しました。"));
      })
      .catch(error => dispatch(openErrorDialog(error)));
  },
  updateAttrReportStatus: params => {
    const errors = [];
    const { id } = ownProps.match.params;

    // 産業分類のエラーチェック
    if ((params.diffIndustry1 && !params.industryParentId1)
      || (params.diffIndustry2 && !params.industryParentId2)
      || (params.diffIndustry3 && !params.industryParentId3)) {
      errors.push('産業分類を選択してください。');
    }

    dispatch(setErrors(errors));
    if (errors.length > 0) {
      window.scroll(0, 0);
      return;
    }

    const reportStatus = {
      reportStatus: params.toJS()
    };
    api
      .post(`survey_progress/update/${id}`, reportStatus)
      .then(res => {
        dispatch(setReportStatus(res, 'update'));
        dispatch(showSnackbar("出力設定を変更しました。"));
      })
      .catch(error => dispatch(openErrorDialog(error)));
  },
  changeReportStatus: (params, method = null) => {
    dispatch(setReportStatus(params, method));
  },
  changeReportByAttrStatus: params => {
    dispatch(setReportByAttrStatus(params));
  },
  changeEditStatus: params => {
    dispatch(setEditStatus(params));
  },
  changeAttrShowStatus: ({ id, attrIndex, itemIndex }, val) => {
    api
      .patch(`update_attr_show_flg/${id}`, { show: val })
      .then(() => {
        dispatch(setSurveyAttrShowStatus(attrIndex, itemIndex, val));
      });
  },
  generateAttrReport: (id, params) => {
    dispatch(setLoading(true));
    api
      .post(`generate_attr_report/${id}`, { attr_item: params })
      .then(() => {
        dispatch(showSnackbar("レポートを作成しています。 数分後にページを更新してください。"));
      })
      .catch((error) => {
        if (error.response.status === 400) {
          dispatch(setLoading(false));
          dispatch(showSnackbar("対象の属性の選択肢を含んだ回答がございません。"));
        } else {
          dispatch(setLoading(false));
          dispatch(openErrorDialog(error));
        }
      });
  },
  getCSV: surveyId => () => {
    dispatch(setLoading(true));
    api
      .get(`result_index_report/${surveyId}/export_csv_result_index_by_question`)
      .then(
        res => {
          createCSVContent(res.data, res.fileName);
          dispatch(setLoading(false));
        }
      )
      .catch(error => {
        dispatch(openErrorDialog(error));
        dispatch(setLoading(false));
      });
  },
  getAttrCSV: (id, params) => {
    dispatch(setLoading(true));
    api
      .get(`result_index_report/${id}/export_csv_result_index_by_question`, { attr_item_id: params })
      .then(
        res => {
          createCSVContent(res.data, res.fileName);
          dispatch(setLoading(false));
        }
      )
      .catch(error => {
        dispatch(openErrorDialog(error));
        dispatch(setLoading(false));
      });
  },
  publicRelease: params => {
    const { id } = ownProps.match.params;
    const reportStatus = {
      reportStatus: params
    };
    api
      .post(`survey_progress/${id}`, reportStatus)
      .then(res => {
        dispatch(setReportStatus(res));
        dispatch(showSnackbar("レポート状態を公開に変更しました。"));
      })
      .catch(error => dispatch(openErrorDialog(error)));
  },
  changeLocale: (event, localeId) => dispatch(setLocale(localeId)),
  handleCloseModal: () => dispatch(closeIndustryModal()),
  handleCloseByAttrModal: () => dispatch(closeIndustryByAttrModal()),
  handleOpenModal: (name, industryParentId, industryId) => {
    dispatch(openIndustryModal(name, industryParentId, industryId));
  },
  handleOpenByAttrModal: (name, industryParentId, industryId, obj = {}) => {
    dispatch(openIndustryByAttrModal(name, industryParentId, industryId, obj));
  },
  handleChange: (name, value) => dispatch(changeIndustryModal(name, value)),
  handleDecideByAttr: () => { dispatch(decideIndustryByAttr()); },
  handleDecide: () =>
    dispatch(decideIndustry()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Report);



// WEBPACK FOOTER //
// ./src/containers/Report/ReportContainer.js